"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _propTypes = require("prop-types");

var _react = require("react");

var _Timeline = _interopRequireDefault(require("@material-ui/icons/Timeline"));

var _CivicSandboxDashboard = _interopRequireDefault(require("../CivicSandboxDashboard/CivicSandboxDashboard"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SandboxDrawerVisualization = function SandboxDrawerVisualization(props) {
  var selectedPackage = props.selectedPackage,
      selectedPackageDescription = props.selectedPackageDescription,
      selectedFoundationDatum = props.selectedFoundationDatum;
  return (0, _core.jsx)(_react.Fragment, null, (0, _core.jsx)("div", {
    css: (0, _core.css)("\n            position: relative;\n            z-index: 900;\n          ")
  }, (0, _core.jsx)("div", {
    css: (0, _core.css)("margin: 0 10px;")
  }, (0, _core.jsx)("h2", null, (0, _core.jsx)(_Timeline["default"], {
    fontSize: "large",
    css: (0, _core.css)("\n                vertical-align: middle;\n                padding-right: 4px;\n              ")
  }), "Data Detail"), (0, _core.jsx)("h3", null, selectedPackage), (0, _core.jsx)("p", null, selectedPackageDescription))), (0, _core.jsx)(_CivicSandboxDashboard["default"], {
    data: selectedFoundationDatum,
    isDashboardOpen: true,
    standalone: true
  }));
};

var _default = SandboxDrawerVisualization;
exports["default"] = _default;
SandboxDrawerVisualization.propTypes = {
  selectedPackage: _propTypes.string,
  selectedPackageDescription: _propTypes.string,
  selectedFoundationDatum: (0, _propTypes.shape)({})
};